import React from "react";
import { ChecklistContainer, ChecklistHeader, ChecklistTitle, ProgressInfo, ChecklistItems, ChecklistItem, CheckCircle, ItemLabel } from "./checklist-styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

interface ChecklistProps {
  items: {
    id: string;
    label: string;
    checked: boolean;
  }[];
}

export const PendenciesChecklist: React.FC<ChecklistProps> = ({ items }) => {
  const completedCount = items.filter((item) => item.checked).length;
  const totalCount = items.length;

  return (
    <ChecklistContainer>
      <ChecklistHeader>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <AssignmentTurnedInIcon sx={{ fontSize: 24, color: "#4285f4" }} />
          <ChecklistTitle>
            Checklist de<br />Pendências
          </ChecklistTitle>
        </div>
        <ProgressInfo>
          Progresso
          <span>
            {completedCount}/{totalCount}
          </span>
        </ProgressInfo>
      </ChecklistHeader>

      <ChecklistItems>
        {items.map((item) => (
          <ChecklistItem key={item.id} $checked={item.checked}>
            <CheckCircle $checked={item.checked}>
              {item.checked ? (
                <CheckCircleIcon />
              ) : (
                <RadioButtonUncheckedIcon />
              )}
            </CheckCircle>
            <ItemLabel $checked={item.checked}>{item.label}</ItemLabel>
          </ChecklistItem>
        ))}
      </ChecklistItems>
    </ChecklistContainer>
  );
};
